import { takeLatest, call, put } from 'redux-saga/effects'
import getProfilesList from 'api/administration/lms-profiles/AllProfilesList'
import * as fromActions from '../../actions/lms-profiles.action'

async function getList() {
  return getProfilesList()
}

function* profilesListEffectSaga() {
  try {
    const data = yield call(getList)
    yield put(fromActions.Actions.lmsAllProfilesSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* profilesListWatcherSaga() {
  yield takeLatest(fromActions.LMS_ALL_PROFILES_LIST, profilesListEffectSaga)
}
